export const JSM_ADOPTION_NUDGES_PACKAGE = 'jsmAdoptionNudges';
export const INVITE_USERS_PROMPTS_KEY = 'jsm-invite-user-prompt';
export const INVITE_USERS_PROMPTS_MESSAGE_ID = 'invite-user-in-jsm-during-key-moments';
export const PROJECTS_WITH_CORE_ACTIONS_TRAIT_NAME =
	'jsm_projects_with_core_actions_and_no_team_invite';
export const JSM_BOARDS_NAV_PROMOTION_KEY = 'jsm-boards-nav-onboarding';
export const JSM_GETTING_STARTED_ROUTE_NAME = 'servicedesk-getting-started-page';
